export class ExcelImportModel{
    excelImportId?:number;
    memberName: string;
    phoneNumber: string;
    email: string;
    constructor( memberName: string ,phoneNumber: string,email: string, excelImportId?:number){
        this.memberName = memberName;
        this.phoneNumber = phoneNumber;
        this.excelImportId = excelImportId;
        this.email = email;
    }
}